var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{attrs:{"id":_vm.id,"title":"Click here to copy a link to this section"},on:{"click":function($event){return _vm.copy($event)}}},[_c('i',{staticClass:"fas fa-hashtag icon"}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }